<template>
  <div class="py-4">
    <div class="color-black-1 font-16 font-weight-normal">
      {{ $t('answerSecurityQuestion') }}
    </div>
    <validation-observer ref="formRef" v-slot="{}" tag="form">
      <div class="pl-4 ml-4 mt-3">
        <span class="color-primary-4 font-16 font-weight-bold d-block">
          {{ $t('question') }}:
        </span>
        <span class="color-black-1 font-16">{{ model.question }}</span>
      </div>
      <div class="mt-3">
        <span
          class="color-primary-4 font-16 font-weight-bold d-block ml-4 pl-4"
        >
          {{ $t('answer') }}:
        </span>
        <validation-provider rules="required" v-slot="{ errors }">
          <custom-form-input
            v-model="model.answer"
            icon="user-circle"
            :error="errors[0]"
            :custom-error-msg="`${$t('RequiredField')}.`"
          />
        </validation-provider>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { CustomFormInput } from '@/components/common';
export default {
  name: 'SecurityQuestion',
  components: {
    CustomFormInput,
  },
  data: () => ({
    model: {
      question: null,
      answer: null,
    },
  }),
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>
